var _path, _path2, _line, _line2, _line3, _line4, _line5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceBackgroundD12Blank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 103 103",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5902 3.10698L77.4447 10.5329C79.4531 11.1854 81.2034 12.4571 82.4447 14.1656L96.5696 33.6068C97.8109 35.3153 98.4794 37.3729 98.4794 39.4847V63.5153C98.4794 65.6271 97.8109 67.6847 96.5696 69.3932L82.4447 88.8344C81.2034 90.5429 79.4531 91.8146 77.4447 92.4671L54.5902 99.893C52.5817 100.546 50.4183 100.546 48.4098 99.893L25.5553 92.4671C23.5469 91.8146 21.7966 90.5429 20.5553 88.8344L6.43042 69.3932C5.18914 67.6847 4.52059 65.6271 4.52059 63.5153V39.4847C4.52059 37.3729 5.18914 35.3153 6.43042 33.6068L20.5553 14.1656C21.7966 12.4571 23.5469 11.1854 25.5553 10.5329L48.4098 3.10698C50.4183 2.4544 52.5817 2.4544 54.5902 3.10698Z",
    fill: "#EAF0FF",
    stroke: "#363636",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4454 38.0936L55.6144 20.7794C53.161 18.9969 49.8388 18.9969 47.3854 20.7794L23.5544 38.0936C21.101 39.8762 20.0744 43.0357 21.0115 45.9199L30.1142 73.9349C31.0513 76.819 33.739 78.7717 36.7716 78.7717H66.2283C69.2608 78.7717 71.9485 76.819 72.8857 73.9349L81.9883 45.9199C82.9254 43.0357 81.8988 39.8762 79.4454 38.0936Z",
    fill: "#EAF0FF",
    stroke: "#363636",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 20,
    x2: 52,
    y2: 4,
    stroke: "#363636",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 81.29,
    y1: 42.8104,
    x2: 96.2479,
    y2: 37.1305,
    stroke: "#363636",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.70989,
    y1: 37.1307,
    x2: 21.6681,
    y2: 42.8098,
    stroke: "#363636",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 23.3853,
    y1: 89.7379,
    x2: 32.8262,
    y2: 76.8201,
    stroke: "#363636",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 79.2103,
    y1: 89.8778,
    x2: 69.4182,
    y2: 77.2242,
    stroke: "#363636",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceBackgroundD12Blank);
export default __webpack_public_path__ + "static/media/DiceBackground_D12_Blank.6a6cc7fac86704761f2e2d2ff5b06181.svg";
export { ForwardRef as ReactComponent };